import { render, staticRenderFns } from "./editClaimRecord.vue?vue&type=template&id=09ae2180&"
import script from "./editClaimRecord.vue?vue&type=script&lang=js&"
export * from "./editClaimRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VForm,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ae2180')) {
      api.createRecord('09ae2180', component.options)
    } else {
      api.reload('09ae2180', component.options)
    }
    module.hot.accept("./editClaimRecord.vue?vue&type=template&id=09ae2180&", function () {
      api.rerender('09ae2180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Claim/ClaimRecord/editClaimRecord.vue"
export default component.exports